module.exports = require('../../modules/_wks-ext').f('toPrimitive');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.11@core-js/library/fn/symbol/to-primitive.js
// module id = oqvD
// module chunks = 80